import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { toast } from "react-toastify";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { FaEllipsisVertical } from "react-icons/fa6";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import { connect } from "react-redux";

function Slider({ onlyPermission }) {
  const baseURL = process.env.REACT_APP_Baseurl

  const indexApi = `${baseURL}/admin/slider/index`
  const deleteApi = `${baseURL}/admin/slider/multi-delete`
  const suffleApi = `${baseURL}/admin/slider/order`

  const { fetchRequest, deleteImageFile } = useMyContext()
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [apiData, setApiData] = useState([]);
  const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(true)
  const [modalClose, setModelClose] = useState(false)
  const [selectAllData, setSelectAllData] = useState(false);
  const [itemDelete, setItemDelete] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [isAutoplay, setIsAutoplay] = useState(0);
  const [autoplayDuration, setAutoplayDuration] = useState(3);
  const [sliderSettingId, setSliderSettingId] = useState(null);
  const [savingSettings, setSavingSettings] = useState(false);
  const [activeTab, setActiveTab] = useState(0); // 0 for Normal, 1 for Ads


  const handleDeleteImage = async () => {
    await deleteImageFile(itemDelete, "Slider");
  }

  const handleDelete = async () => {
    setShowOverlay(true);
    handleCloseModal()
    await handleDeleteImage();
    try {
      const response = await fetchRequest({
        method: 'DELETE',
        url: `${deleteApi}`,
        params: {},
        data: { id: [...itemDelete] },
      })

      const result = response;
      if (result?.status) {
        toast.success(result?.message)
        setWithOutRefresh(!withOutRefresh)
        setSelectAllData(false)
      }
    }
    catch (err) {
      const errMessage = err?.response?.data?.message
      toast.error(errMessage)
    }
    finally {
      setLoading(false)
      setShowOverlay(false);
    }
  }

  const saveShuffleOrder = async (updatedItems) => {
    setShowOverlay(true);

    if (!updatedItems || updatedItems?.length === 0) {
      toast.error("Menu items are empty");
      return;
    }
    else {
      const ids = updatedItems?.map((menuItem) => menuItem?.id);
      const positions = updatedItems?.map((_, index) => index + 1);
      const requestData = {
        id: ids,
        position: positions,
      };
      try {
        const response = await fetchRequest({
          method: 'POST',
          url: `${suffleApi}`,
          params: {},
          data: requestData,
        })
        const result = response;
        if (result?.status) {
          toast.success(result?.message)
          setWithOutRefresh(!withOutRefresh)
          setShowOverlay(false);
        }
        else {
          setShowOverlay(false)
          toast.error(result?.message)
        }
      } catch (err) {
        setShowOverlay(false)
        console.error(err);
        var errorMessage = err?.response?.data?.message;
        toast.error(errorMessage)
      }
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const filteredData = apiData.filter(item => (activeTab === 1 ? item.is_ads === 1 : !item.is_ads || item.is_ads === 0));
    const reorderedFiltered = Array.from(filteredData);
    const [movedItem] = reorderedFiltered?.splice(result.source.index, 1);
    reorderedFiltered?.splice(result.destination.index, 0, movedItem);

    // Update the main apiData with the new order for the filtered items
    const newApiData = [...apiData];
    let filteredIndex = 0;
    apiData.forEach((item, index) => {
      const isExpectedType = (activeTab === 1 ? item.is_ads === 1 : !item.is_ads || item.is_ads === 0);
      if (isExpectedType) {
        newApiData[index] = reorderedFiltered[filteredIndex++];
      }
    });

    setApiData(newApiData);
    saveShuffleOrder(reorderedFiltered);
  };

  const handleSelectAllData = () => {
    setSelectAllData(!selectAllData);
    const filteredData = apiData.filter(item => (activeTab === 1 ? item.is_ads === 1 : !item.is_ads || item.is_ads === 0));
    setItemDelete(selectAllData ? [] : filteredData?.map((item) => item?.id));
  };

  const handleSingleFile = (itemId) => {
    if (itemDelete?.includes(itemId)) {
      setItemDelete(
        itemDelete?.filter((id) => id !== itemId)
      );
    } else {
      setItemDelete([...itemDelete, itemId]);
    }
  };

  const handleCloseModal = () => {
    setModelClose(!modalClose)
    setItemDelete([]);
  }

  const handleOpenDeleteModal = async () => {
    setModelClose(true)
  }

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setSelectAllData(false);
    setItemDelete([]);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemDelete([id]);
  };

  useEffect(async () => {
    setShowOverlay(true)
    // Fetch slider settings
    try {
      const settingsResponse = await fetchRequest({
        method: 'GET',
        url: `${baseURL}/admin/slider-settings/index`,
      });
      if (settingsResponse?.status) {
        setIsAutoplay(settingsResponse.sliderSetting?.is_autoplay ?? 1);
        setAutoplayDuration(settingsResponse.sliderSetting?.autoplay_duration ?? 3);
        setSliderSettingId(settingsResponse.sliderSetting?.id);
      }
    } catch (error) {
      console.error("Error fetching slider settings:", error);
    }

    await fetchRequest({
      method: 'GET',
      url: `${indexApi}`,
      params: {},
      data: {},
    })
      .then(response => {
        if (response?.status) {
          setApiData(response?.slider)
          setLoading(false);
        }
      }).catch((error => {
        setLoading(false);
        toast.error(error?.response?.data?.message)
      })).finally(() => {
        setShowOverlay(false)
        setLoading(false);
      })
  }, [withOutRefresh])

  const handleUpdateSettings = async () => {
    setSavingSettings(true);
    setShowOverlay(true);
    try {
      const response = await fetchRequest({
        method: 'POST',
        url: `${baseURL}/admin/slider-settings/update`,
        data: {
          is_autoplay: isAutoplay ? 1 : 0,
          autoplay_duration: parseInt(autoplayDuration) || 3
        }
      });
      if (response?.status) {
        toast.success(response.message || "Settings updated successfully");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update settings");
    } finally {
      setSavingSettings(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      {showOverlay && <Response_Processing />}
      {modalClose && <AdminDeleteModal modelClose={modalClose} deleteClose={closeModal} deleteAction={handleDelete} buttonText={"custom"} message={itemDelete?.length > 1 ? " Are you sure you want to delete the selected Slider ?" : "Are you sure you want to delete this Slider?"} />}
      <AdminNavbar heading={(activeTab === 1 && onlyPermission?.includes(48)) ? 'Promotional Ads Slider' : 'Normal Slider'} totalDataLength={apiData.filter(item => ((activeTab === 1 && onlyPermission?.includes(48)) ? item.is_ads === 1 : !item.is_ads || item.is_ads === 0)).length} deleteCount={itemDelete?.length} navigation={'/addslider'} deleteMethod={handleOpenDeleteModal} navText={'Add Slider'} navState={{ is_ads: activeTab }} />

      {onlyPermission?.includes(48) && (
        <div className="d-flex align-items-center gap-3 mb-3">
          <button
            onClick={() => { setActiveTab(0); setItemDelete([]); setSelectAllData(false); }}
            className={`px-4 py-2 rounded-2 border-0 ${activeTab === 0 ? 'button-bg-color theme-button-text-color' : 'theme-bg-color theme-text-color theme-border-color border'}`}
          >
            Normal Slider
          </button>

          <button
            onClick={() => { setActiveTab(1); setItemDelete([]); setSelectAllData(false); }}
            className={`px-4 py-2 rounded-2 border-0 ${activeTab === 1 ? 'button-bg-color theme-button-text-color' : 'theme-bg-color theme-text-color theme-border-color border'}`}
          >
            Promotional Ads Slider
          </button>

        </div>
      )}

      <div className="theme-bg-color p-3 rounded-2 mb-3 d-flex align-items-center justify-content-end gap-4 shadow-sm border theme-border-color">
        <div className="d-flex align-items-center gap-2">
          <span className="theme-text-color admin-input-title mb-0">Enable Autoplay</span>
          <label className="switch mb-0">
            <input
              type="checkbox"
              checked={isAutoplay === 1}
              onChange={(e) => setIsAutoplay(e.target.checked ? 1 : 0)}
            />
            <span className="slider round"></span>
          </label>
        </div>

        {isAutoplay === 1 && (
          <div className="d-flex align-items-center gap-2">
            <span className="theme-text-color admin-input-title mb-0">Duration (sec)</span>
            <input
              type="number"
              className="theme-bg-color theme-text-color border theme-border-color rounded px-2 py-1"
              style={{ width: "70px", outline: "none" }}
              value={autoplayDuration}
              onChange={(e) => setAutoplayDuration(e.target.value)}
              min="1"
            />
          </div>
        )}

        <button
          onClick={handleUpdateSettings}
          disabled={savingSettings}
          className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-4 border-0"
        >
          {savingSettings ? "Saving..." : "Save Settings"}
        </button>
      </div>

      <div className="bootstrapTable theme-bg-color p-3 rounded-2">
        <div className="">
          <div className="row m-0 theme-border-bottom-secondary pb-3">
            <div className="rowCheckboxDrag col-2"> <label><input type="checkbox" checked={selectAllData} onChange={handleSelectAllData} /> </label></div>
            {activeTab === 0 ? (
              <>
                <div className="col-2 "> <label className="theme-text-color fw-bold fs-6"> Slider Name </label> </div>
                <div className="col-3 "><label className="theme-text-color fw-bold fs-6">Slider Image</label></div>
                <div className="col-3"><label className="theme-text-color fw-bold fs-6">Player Image</label></div>
              </>
            ) : (
              <>
                <div className="col-2 "> <label className="theme-text-color fw-bold fs-6"> Ads Title </label> </div>
                <div className="col-3 "><label className="theme-text-color fw-bold fs-6">Ads Banner</label></div>
                <div className="col-3"><label className="theme-text-color fw-bold fs-6">CTA Button</label></div>
              </>
            )}
            <div className="col-2"> <label className="theme-text-color fw-bold fs-6">Actions</label></div>
          </div>
        </div>
      </div>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="menu-items" className="theme-bg-color"   >
          {(provided) => (
            <ul  {...provided.droppableProps} ref={provided.innerRef} className="pb-5 px-0 theme-bg-color m-0 p-0 list-unstyled">
              {loading ? <NoRecordTable result={apiData?.length} loader={true} /> :
                apiData?.filter(item => (activeTab === 1 ? item.is_ads === 1 : !item.is_ads || item.is_ads === 0))?.length ? apiData?.filter(item => (activeTab === 1 ? item.is_ads === 1 : !item.is_ads || item.is_ads === 0))?.map((item, index) => (
                  <Draggable key={item?.id.toString()} draggableId={item?.id.toString()} index={index} >
                    {(provided) => (
                      <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={` theme-bg-color theme-text-color   ${item.order} index ${index + 1} w-100 theme-border-bottom-secondary px-3 py-3`} >
                        <div className="row m-0 p-0 align-items-center">

                          <div className="rowCheckboxDrag category-order-title" style={{ cursor: 'default' }} >
                            <input type="checkbox" checked={itemDelete?.includes(item.id)} onChange={() => handleSingleFile(item.id)} style={{ cursor: 'default' }} />
                          </div>
                          {activeTab === 0 ? (
                            <>
                              <div className="col-2 category-order-title">
                                <div className="rightVideoTitle d-flex flex-column ">
                                  <MessageBox text={item?.title?.length > 15 ? `${item.title.slice(0, 15)}...` : item?.title} classname="admin-input-title" loadingHide />
                                  <span className="dateText table-subheading "> {item?.upload_on}</span>
                                </div>
                              </div>
                              <div className="col-3">
                                <img src={item?.slider_image_url} className="rounded-3 slider-image-banner object-fit-cover" />
                              </div>
                              <div className="col-3">
                                <img src={item?.slider_player_image_url} className="rounded-3 slider-image-banner object-fit-cover" />
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="col-2 category-order-title">
                                <div className="rightVideoTitle d-flex flex-column ">
                                  <MessageBox text={item?.ads_title?.length > 15 ? `${item.ads_title.slice(0, 15)}...` : item?.ads_title} classname="admin-input-title" loadingHide />
                                  <span className="dateText table-subheading "> {item?.upload_on}</span>
                                </div>
                              </div>
                              <div className="col-3">
                                <img src={item?.ads_banner_url} className="rounded-3 slider-image-banner object-fit-cover" />
                              </div>
                              <div className="col-3">
                                <MessageBox text={item?.cta_button_name} classname="admin-input-title" loadingHide />
                              </div>
                            </>
                          )}

                          <div className="col-2 category-order-title">
                            <div className="editdropdown">
                              <span className="editdropdown-button">
                                <FaEllipsisVertical className="theme-text-color" />
                              </span>
                              <div className="editdropdown-menu theme-bg-color">
                                <Link to={`/editslider/${item?.id}`} className="theme-text-color theme-bg-color">
                                  <IconEditFigma styled={{ width: "24px", height: "24px" }} />
                                  <span className="theme-text-color">
                                    <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
                                  </span>
                                </Link>
                                <div onClick={() => singleDelete(item?.id)} className="commonActionPadding theme-bg-color">
                                  <IconDeleteFigma styled={{ width: "24px", height: "24px" }} />
                                  <MessageBox text="Delete" classname='ms-2 theme-text-color'></MessageBox>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    )}
                  </Draggable>
                )) : <NoRecordTable result={apiData?.length} loader={false} />}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
}

const mapStateToProps = (state) => ({
  onlyPermission: state.userPermission.onlyPermission
});

export default connect(mapStateToProps)(Slider);